/**
 * defaultCardLogos.js — per-tenant fallback cover image, shared by any rich
 * card (wine, membership, tasting, event, ...) when the card's own image
 * (cover_image_link / imageUrl / etc.) is missing.
 *
 * Static imports (esbuild bundles each as a URL/data-uri), keyed by tenant id.
 * To add another winery's default logo: drop the file in assets/images/,
 * import it below, and add one map entry — no other wiring needed.
 */

import { getTenantId } from "./configAccessors.js";
import lightningRockLogo from "../assets/images/LR-bg.png";
import pottersLogo from "../assets/images/PVLogo.png"


const DEFAULT_CARD_LOGOS = {
  lightningrockwinery: lightningRockLogo,
  pottersvineyard: pottersLogo
};

export function getDefaultCardLogo() {
  return DEFAULT_CARD_LOGOS[getTenantId()] || null;
}
